import type { FaireProductEntity } from "../../entity_types/product";

export const p_sa3s9yzyg7: FaireProductEntity = {
  token: "p_sa3s9yzyg7",
  type: "product",
  name: "Cece Body Wash",
  brandToken: "b_8aa5kchc2z",
  brandName: "Homecourt",
  imageUrl:
    "https://cdn.faire.com/fastly/28cf488232c7a053d2086851e04e7017d40f68debe7da345dc07d439aefa0292.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0cda2139c7a222abcfab54cf985efbd7444967f8820f4dae0b3d08fd6e303168.jpeg",
    "https://cdn.faire.com/fastly/cbb9ff679689bb463ac842dd8906e7ad7fbcae8043ac2202690e78752642fa0f.jpeg",
    "https://cdn.faire.com/fastly/5935d144282221dacca1d987a5233ea06bc19c6cd05d783f3cee994f84cf1bf3.jpeg",
    "https://cdn.faire.com/fastly/4a01c518d8b8b6ce5da911a618a60902c3fec48dc9939fc20e5bb01697b7908e.jpeg",
  ],
  priceDollars: 19.8,
  description:
    "2024 Glamour Beauty and Wellness Award Winner – Best Body Wash\n\nSize: 10 fl oz / 295 ml\n\nDiscover why our luxury body wash was named the Best Body Wash of 2024 by Glamour. This hydrating body cleanser transforms your daily shower into a spa-like ritual—leaving skin refreshed, silky-soft, and lightly perfumed with fine fragrance.\n\n𝐖𝐡𝐲 𝐈𝐭 𝐖𝐨𝐫𝐤𝐬\n•Upcycled sugar beet extract delivers natural, sustainable moisture.\n•Organic rosella extract provides up to 72-hour hydration for long-lasting softness.\n•Vitamin B5 supports a healthy skin barrier and locks in hydration.\n•100% plant-derived glucose smooths and strengthens skin.\n•Naturally derived polymers condition skin for a rich, creamy lather.\n\n𝐃𝐢𝐫𝐞𝐜𝐭𝐢𝐨𝐧𝐬 𝐟𝐨𝐫 𝐔𝐬𝐞\nApply generously onto wet skin, massage into a luxurious lather, then rinse thoroughly.\n\n𝐓𝐡𝐞 𝐂𝐞𝐜𝐞 𝐒𝐜𝐞𝐧𝐭\nGrounded yet addictive, Cece is our founder’s signature fragrance: a warm blend of cedarwood smoke, cardamom, cinnamon, and white leather that lingers beautifully on the skin.\n\n𝐅𝐫𝐚𝐠𝐫𝐚𝐧𝐜𝐞 𝐍𝐨𝐭𝐞𝐬:\n•Guatemalan cardamom*\n•Dried mate absolute leaves*\n•Sri Lankan cinnamon*\n•Carrot seeds and leaves\n•Indonesian patchouli oil*\n•Vetiver oil*\n\n*Eco-friendly and/or sustainably sourced",
  tags: [],
  msrpDollars: 36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-28T15:36:19.106Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
